import { Switch, Route, Redirect, useLocation } from "wouter";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Loader2 } from "lucide-react";
import NotFound from "@/pages/not-found";
import AuthPage from "@/pages/auth-page";
import LoginPage from "@/pages/authPage-login";
import ResetPasswordPage from "@/pages/reset-password";
import DocumentsPage from "@/pages/documents-page";
import PaymentsPage from "@/pages/payments-page";
import MessagesPage from "@/pages/messages-page";
import AIChatPage from "@/pages/ai-chat-page";
import OnboardingPage from "@/pages/onboarding-page";
import assetLink from "@/pages/assetLink.json";
import SignaturesPage from "@/pages/signatures-page";
import AppointmentsPage from "@/pages/appointments-page";
import CasesPage from "@/pages/cases-page";
import IDVerificationPage from "@/pages/id-verification-page";
import IDVerificationUploadPage from "@/pages/id-verification-upload-page";
import WelcomeConfirmationPage from "@/pages/welcome-confirmation-page";
import GbgTestPage from "@/pages/gbg-test-page";
import { ProtectedRoute } from "@/lib/protected-route";
import { ObiTipsProvider } from "@/hooks/use-obi-tips";
import { AuthProvider } from "@/hooks/use-auth";
import { OnboardingProvider, useOnboarding } from "@/hooks/use-onboarding";
import { useAuth } from "@/hooks/use-auth";
import PrivacyPage from "@/pages/privacy-policy";
import StopReminders from "@/pages/stop-reminder";
import WebPrivacyPolicy from "@/pages/web-privacy";
import RegistrationCodeInput from "@/pages/account-activation";
import CreateUserForm from "@/pages/create-test-user";
import { useEffect, useState, useRef } from "react";
import IdleLogoutHandler from "@/features/authentication/IdleLogoutHandler";
import LandingPage from "./pages/landing-page";
import PaymentSuccessPage from "./pages/payment-success";
import PaymentFailedPage from "./pages/payment-fail";
import SubmissionConfirmationPage from "./pages/submission-confirmation-page";

function OnboardingRedirect() {
  const { shouldShowOnboarding } = useOnboarding();
  const { user, isLoading } = useAuth();

  console.log("Dashboard redirect - User data:", user);
  console.log("Dashboard redirect - Is first login:", user?.isFirstLogin);
  console.log(
    "Dashboard redirect - Welcome viewed:",
    sessionStorage.getItem("welcome_viewed")
  );
  console.log(
    "Dashboard redirect - Should show onboarding:",
    shouldShowOnboarding
  );

  // Prevent rendering until we have user data loaded
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }
  if (!user) {
    return <Redirect to="/landing-page" />;
  }
  // If user is on their first login, show the welcome confirmation screen
  if (user?.isFirstLogin && !sessionStorage.getItem("welcome_viewed")) {
    console.log("Dashboard redirect - Redirecting to welcome page...");
    return <Redirect to="/welcome" />;
  } else {
    return <Redirect to="/onboarding" />;
  }
}

function Routes() {
  const [authType, setAuthType] = useState("");

  return (
    <Switch>
      <ProtectedRoute path="/" component={OnboardingRedirect} />
      <ProtectedRoute path="/onboarding" component={OnboardingPage} />
      <ProtectedRoute path="/welcome" component={WelcomeConfirmationPage} />
      <Route path="/privacy" component={PrivacyPage} />
      <Route path="/web-privacy" component={WebPrivacyPolicy} />
      <Route path="/stop-reminder" component={StopReminders} />
      <Route path="/account-activation" component={RegistrationCodeInput} />
      <Route path="/create-test-user" component={CreateUserForm} />
      <Route path="/register" component={() => <AuthPage />} />
      <Route path="/login" component={() => <LoginPage />} />
      <Route path="/reset-password" component={ResetPasswordPage} />
      <Route
        path="/landing-page"
        component={() => <LandingPage setAuthType={setAuthType} />}
      />
      <Route path="/payment-success" component={PaymentSuccessPage} />
      <Route path="/payment-fail" component={PaymentFailedPage} />
      <ProtectedRoute path="/submission-confirmation" component={SubmissionConfirmationPage} />
      <Route component={NotFound} />

      {/* <Route path="/.well-known/assetlinks.json" component={assetLink} /> */}
      {/*
      <ProtectedRoute path="/documents" component={DocumentsPage} />
      <ProtectedRoute path="/payments" component={PaymentsPage} />
      <ProtectedRoute path="/messages" component={MessagesPage} />
      <ProtectedRoute path="/ai-chat" component={AIChatPage} />
      <ProtectedRoute path="/signatures" component={SignaturesPage} />
      <ProtectedRoute path="/appointments" component={AppointmentsPage} />
      <ProtectedRoute path="/cases" component={CasesPage} />
      <ProtectedRoute path="/id-verification" component={IDVerificationPage} />
      <ProtectedRoute
        path="/id-verification/upload"
        component={IDVerificationUploadPage}
      />
      <ProtectedRoute path="/gbg-test" component={GbgTestPage} /> */}
    </Switch>
  );
}

function App() {
  const [timeoutMinutes, setTimeoutMinutes] = useState(15);
  useEffect(() => {
    fetch("/api/config")
      .then((res) => res.json())
      .then((data) => {
        if (data?.timeoutMinutes) setTimeoutMinutes(data.timeoutMinutes);
      })
      .catch(() => {
        // ignore errors; fallback remains 15
      });
  }, []);
  return (
    <AuthProvider>
      <OnboardingProvider>
        <ObiTipsProvider>
          <TooltipProvider>
            <Toaster />
            <IdleLogoutHandler timeoutMinutes={timeoutMinutes} />
            <Routes />
          </TooltipProvider>
        </ObiTipsProvider>
      </OnboardingProvider>
    </AuthProvider>
  );
}

export default App;
